/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { Trans, useLingui } from '@lingui/react/macro';
import { Zap } from 'lucide-react';
import React from 'react';
import UDText from 'ud-ui/components/text';
import { AnalyticsFastestGoalRecord } from 'modules/analytics/domain/interfaces/tournament-analytics';
import RecordCardShell from './record-card-shell';

interface FastestGoalCardProps {
  record: AnalyticsFastestGoalRecord | null;
  className?: string;
}

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

const Seconds = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 18px;
  border-radius: ${({ theme }) => theme.radii.card};
  background: ${({ theme }) => theme.colors.SurfaceSunken};
`;

const FastestGoalCard = React.memo(({ record, className }: FastestGoalCardProps) => {
  const { t } = useLingui();
  const title = t`Самый быстрый гол`;
  const icon = <Zap size={20} />;

  if (record === null) {
    return <RecordCardShell icon={icon} title={title} tone="amber" isEmpty className={className} />;
  }

  const { goalSecond } = record;

  return (
    <RecordCardShell
      icon={icon}
      title={title}
      tone="amber"
      championshipName={record.championshipName}
      matchDate={record.matchDate}
      className={className}
    >
      <Row>
        <UDText variant="title-3" as="div" className="!text-inkPrimary">
          {record.playerName}
        </UDText>
        <Seconds>
          <UDText variant="title-1" as="span" className="!text-inkPrimary leading-none">
            <Trans>{goalSecond} сек.</Trans>
          </UDText>
        </Seconds>
      </Row>
    </RecordCardShell>
  );
});

export default FastestGoalCard;
